import { SpaceBetween } from "@cloudscape-design/components-themed";
import PriorPayoutCreditCardMerchantNumbers from "../components/prior-payout/PriorPayoutCreditCardMerchantNumbers";
import { createRef, useCallback, useEffect, useState } from "react";
import { CONFIGS, LABELS } from "../components/prior-payout/constants";
import { useLocation } from "react-router-dom";
import PriorPayoutShopIds from "../components/prior-payout/PriorPayoutShopIds";
import ErrorTable, { MessageItem } from "../components/UI/table/ErrorTable";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 * ID払い出し結果受領・取込
 * URLからshopIdまたはクレカ加盟店番号の判定を行う。
 * エラー内容のテーブルは共通定義
 */
const PriorPayout = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.EXAMINE);
  // URLを取得
  const pathname = useLocation().pathname;

  // エラーメッセージ表示処理用
  const [errorMessageList, setErrorMessageList] = useState<MessageItem[]>([]);
  const errorRef = createRef<HTMLDivElement>();
  // このコールバックを呼び出して ref.current.scrollIntoView() を呼び出してスクロール
  const scrollToBottomOfList = useCallback(() => {
    // エラー内容にスクロール
    errorRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorRef]);

  useEffect(() => {
    // ページが描画されたらリストの末尾までスクロール
    scrollToBottomOfList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessageList]);

  return (
    <SpaceBetween size="l">
      {pathname.includes(CONFIGS.CREDIT_CARD_MERCHANT_NUMBERS) && (
        <PriorPayoutCreditCardMerchantNumbers
          setErrorMessageList={setErrorMessageList}
        />
      )}
      {pathname.includes(CONFIGS.SHOP_IDS) && (
        <PriorPayoutShopIds setErrorMessageList={setErrorMessageList} />
      )}
      {0 !== errorMessageList.length && (
        <>
          <ErrorTable data={errorMessageList} title={LABELS.ERROR_TITLE} />
          <div id="idError" ref={errorRef} />
        </>
      )}
    </SpaceBetween>
  );
};

export default PriorPayout;
